import React from "react";
import Close from "../assets/svg/close.svg";
import Logo from "../assets/svg/logo192.png";

import { motion } from "framer-motion";

export default function UpgradePopper(props) {
  const { off, clicked, startedtrial } = props;
  return (
    <motion.div
      style={{
        background: "#EE1D52",
        padding: "10px",
        position: "absolute",
        zIndex: 9999999,
        width: "80%",
        left: 0,
        right: 0,
        top: "100px",
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: "7px",
      }}
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", duration: 1.4 }}
    >
      <div
        onClick={(e) => off(false)}
        style={{ position: "absolute", right: "15px", top: "15px" }}
      >
        <img src={Close} alt="close" style={{ maxHeight: "20px" }}></img>
      </div>

      <div className="yalla">
        <p style={{ textAlign: "center" }}>
          <img
            src={Logo}
            alt="fitzet logo"
            style={{ height: "70px", width: "70px", borderRadius: "7px" }}
          />
        </p>

        {startedtrial ? (
          <h3 style={{ textAlign: "center" }}>Essayez BoxFit Premium</h3>
        ) : (
          <h3 style={{ textAlign: "center" }}>Essayez BoxFit Premium gratuitement</h3>
        )}

        <p style={{ fontSize: "16px", textAlign: "center", padding: "5px" }}>
          Profitez de plus de 390 nouveaux exercices, des fonctionnalités premium comme l'historique d'entraînement radar de poids et l'accès à de nouvelles catégories.{" "}
          {startedtrial ? "" : "Essai de 7 jours, annuler à tout moment"}
        </p>

        <button
          style={{
            fontSize: "18px",
            background: "#000",
            padding: "10px",
            border: 0,
            borderRadius: "4px",
            fontWeight: "600",
            width: "100%",
            color: "white",
          }}
          onClick={() => {
            clicked();
          }}
        >
          <span role="img" aria-label="like">
            👉
          </span>{" "}
          {startedtrial ? "Version Premium" : "Essai GRATUIT"}
        </button>
        <div style={{ height: "10px" }}></div>
      </div>
    </motion.div>
  );
}
